// Brand & content constants for Sardaar Stevedoring Pvt. Ltd.

export const BRAND = {
  name: "Sardaar Stevedoring Pvt. Ltd.",
  short: "Sardaar Stevedoring",
  tagline: "Anchored in Heritage. Engineered for Cargo.",
  established: 1970,
  logo: "https://customer-assets.emergentagent.com/job_sardaar-stevedore/artifacts/1mo1l8ua_logo.jpg",
};

export const CONTACT = {
  address: "Plot No. 802, Sikharpur Nadikula Sahi, P.O. Nayabazaar, Cuttack, Odisha — 753004",
  phones: ["+91 93373 55953", "+91 67140 49921"],
  email: "info@sardaarstevedoring.com",
  mapEmbed:
    "https://www.google.com/maps?q=Nayabazaar+Cuttack+Odisha+753004&output=embed",
};

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "Heritage" },
  { id: "services", label: "Services" },
  { id: "timeline", label: "Milestones" },
  { id: "leadership", label: "Leadership" },
  { id: "gallery", label: "Gallery" },
  { id: "clients", label: "Clients" },
  { id: "contact", label: "Contact" },
];

export const STATS = [
  { value: "55+", label: "Years of Legacy", note: "Group experience since 1970" },
  { value: "20,00,000+", label: "MT Cargo Handled", note: "Across Eastern India" },
  { value: "21", label: "Owned Heavy Vehicles", note: "" },
  { value: "Paradip · Gopalpur · Vizag", label: "Ports of Operation", note: "", compact: true },
];

export const SERVICES = [
  {
    icon: "Anchor",
    title: "Stevedoring and Port Operations",
    body:
      "End-to-end loading, discharging and on-board cargo supervision at major and minor ports along the Eastern Indian coastline.",
  },
  {
    icon: "Container",
    title: "Cargo Handling",
    body:
      "Handling of all types of goods — fertilisers, food grains, edible oils, cement, bagged cargo and project consignments.",
  },
  {
    icon: "Truck",
    title: "Transportation and Logistics",
    body:
      "A modern fleet of 21 owned heavy commercial vehicles serving Odisha and pan-India with disciplined dispatch and on-time delivery.",
  },
  {
    icon: "Warehouse",
    title: "Warehousing Solutions",
    body:
      "Custom warehousing and built-to-suit logistics properties, supported by an in-house weighbridge at New Malgodown, Cuttack.",
  },
  {
    icon: "FileText",
    title: "C and F Agency Services",
    body:
      "Carrying and Forwarding services for marquee clients, with proven experience as authorised representative for Indian Potash Limited.",
  },
  {
    icon: "Ship",
    title: "Bulk Imports and Exports",
    body:
      "Decades of experience handling imported commodities through partnered stevedoring at Ports.",
  },
];

export const TIMELINE = [
  {
    year: "1970",
    title: "The Foundation",
    body:
      "Late Shri Narahari Nayak — known across the industry as Nari Sardar — founded Sardar Roadlines on principles of integrity, discipline and long-term relationships.",
  },
  {
    year: "1983",
    title: "Bargarh Rail Siding · IFFCO",
    body:
      "Appointed cargo handler and transporter for IFFCO operations at the Bargarh Rail Siding — successfully moving over 5,00,000 metric tonnes across Bolangir, Kesinga, Sinapali and beyond.",
  },
  {
    year: "1986–87",
    title: "Imports via OSL",
    body:
      "Major transportation of imported rice from Australia, edible oil, peas and sugar from the United States — with OSL as appointed stevedore. A defining stretch of bulk-import experience.",
  },
  {
    year: "1990's",
    title: "Gopalpur Port Operations",
    body:
      "Executed multiple large-scale assignments at Gopalpur Port and Visakhapatnam — including rice bagging — strengthening expertise in port-based logistics and bulk movement.",
  },
  {
    year: "Today",
    title: "Sardaar Stevedoring Pvt. Ltd.",
    body:
      "The same family, the same discipline — now formally constituted to deliver dedicated stevedoring and port-handling services across Eastern India.",
  },
];

export const CLIENTS = [
  "IFFCO",
  "Indian Potash Limited",
  "Paradip Phosphates Limited",
  "Food Corporation of India",
  "Larsen & Toubro",
  "Tata Consumer Products",
  "Maha Cement",
  "Indian Oil Corporation",
  "Hindustan Petroleum",
  "TOTAL Lubricants",
];

// Heritage photographs supplied by the client
export const HERITAGE_PHOTOS = [
  {
    url: "https://customer-assets.emergentagent.com/job_sardaar-stevedore/artifacts/egp7y65d_WhatsApp%20Image%202026-05-05%20at%205.26.40%20PM.jpeg",
    caption: "Late Shri Narahari Nayak — the founder, fondly known as Nari Sardar.",
    span: "tall",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_sardaar-stevedore/artifacts/mdusy59r_WhatsApp%20Image%202026-05-05%20at%205.21.05%20PM.jpeg",
    caption: "The family with the early fleet — a tradition of trucks blessed before every journey.",
    span: "wide",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_sardaar-stevedore/artifacts/s4cjg3op_WhatsApp%20Image%202026-05-05%20at%205.23.11%20PM.jpeg",
    caption: "Operations at hand — coordinating cargo movements across Eastern India.",
    span: "default",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_sardaar-stevedore/artifacts/ftjs8qbs_WhatsApp%20Image%202026-05-05%20at%205.24.19%20PM.jpeg",
    caption: "Leadership and partners — relationships built across decades.",
    span: "default",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_sardaar-stevedore/artifacts/r9nv44yo_WhatsApp%20Image%202026-05-05%20at%205.20.14%20PM.jpeg",
    caption: "The workforce — the backbone of every successful consignment.",
    span: "wide",
  },
];

// Real port operations photograph supplied by the client
const REAL_PORT = "https://customer-assets.emergentagent.com/job_sardaar-stevedore/artifacts/h7b9tw5w_WhatsApp%20Image%202026-05-05%20at%206.10.01%20PM.jpeg";

// Imagery — real photographs (client-supplied) + 2 supporting stock visuals for variety
export const MEDIA = {
  hero: REAL_PORT,
  aboutSide: REAL_PORT,
  services: {
    Anchor: REAL_PORT,
    Container: REAL_PORT,
    Truck: REAL_PORT,
    Warehouse: REAL_PORT,
    FileText: REAL_PORT,
    Ship: REAL_PORT,
  },
  gallery: [REAL_PORT],
};

// Leadership — three generations of the same family, at the helm
export const LEADERSHIP = [
  {
    name: "Late Shri Narahari Nayak",
    altName: "Nari Sardar",
    role: "Founder and Visionary",
    generation: "First Generation",
    note: "Founded the legacy in 1970 with Sardar Roadlines — built the family's name on integrity, discipline and long-term relationships.",
    photo: "https://customer-assets.emergentagent.com/job_sardaar-stevedore/artifacts/s4cjg3op_WhatsApp%20Image%202026-05-05%20at%205.23.11%20PM.jpeg",
  },
  {
    name: "Narayan Nayak",
    role: "Chairman and Managing Director",
    generation: "Second Generation",
    note: "",
    photo: "https://customer-assets.emergentagent.com/job_sardaar-stevedore/artifacts/qvx14042_WhatsApp%20Image%202026-05-05%20at%2010.06.44%20PM.jpeg",
  },
  {
    name: "Anshul Nayak",
    role: "Chief Executive Officer",
    generation: "Third Generation",
    note: "",
    photo: "https://customer-assets.emergentagent.com/job_sardaar-stevedore/artifacts/nanes0pw_WhatsApp%20Image%202026-05-05%20at%206.33.19%20PM.jpeg",
  },
  {
    name: "Spandan Jena",
    role: "Managing Director · Operations",
    generation: "Third Generation",
    note: "",
    photo: "https://customer-assets.emergentagent.com/job_sardaar-stevedore/artifacts/z9l9vehb_WhatsApp%20Image%202026-05-05%20at%206.33.45%20PM.jpeg",
  },
  {
    name: "Satyabrata Satapathy",
    role: "Managing Director · Commercials",
    generation: "Third Generation",
    note: "",
    photo: "https://customer-assets.emergentagent.com/job_sardaar-stevedore/artifacts/ntnoprg6_WhatsApp%20Image%202026-05-05%20at%206.40.02%20PM.jpeg",
  },
];

export const SISTER_CONCERNS = [
  "Sardar Roadlines",
  "Mahavir Transport",
  "Narahari Nayak Transport",
  "Nayak & Associates",
];
